import * as React from 'react';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function SimpleServiceCard({ serviceTitle, validity, price, onSelect }) {
  return (
    <Card className="w-full max-w-md border rounded-2xl shadow-md font-primary flex flex-col justify-between p-1">
      
      {/* Title row with icon */}
      <CardHeader className="flex flex-row items-center gap-2 text-[#5180CA] pb-2">
        <GiftIcon className="w-6 h-6 shrink-0 text-primary" />
        <span className="text-xl font-semibold leading-tight">
          {serviceTitle}
        </span>
      </CardHeader>

      {/* Info row with wrapping */}
      <CardContent className="pb-2 pt-0">
        <div className="flex flex-wrap gap-x-10 gap-y-2 text-left">
          {validity && (
            <InfoItem label="Galiojimas" value={`${validity} mėn.`} />
          )}
          <InfoItem label="Kaina" value={`${price}`} />
        </div>
      </CardContent>

      {/* Button */}
      <CardFooter>
        <Button
          className="!w-full bg-[#F9FCFF] text-[#1F4B81] rounded-xl"
          onClick={onSelect}
        >
          Rinktis
        </Button>
      </CardFooter>
    </Card>
  );
}

const InfoItem = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-sm text-[#9CA3AF]">{label}</span>
    <span className="text-lg font-medium text-[#1F2937] leading-snug">
      {value}
    </span>
  </div>
);

const GiftIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M11 14v8h-4a3 3 0 0 1 -3 -3v-4a1 1 0 0 1 1 -1h6zm8 0a1 1 0 0 1 1 1v4a3 3 0 0 1 -3 3h-4v-8h6zm-2.5 -12a3.5 3.5 0 0 1 3.163 5h.337a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-7v-5h-2v5h-7a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.337a3.486 3.486 0 0 1 -.337 -1.5c0 -1.933 1.567 -3.5 3.483 -3.5c1.755 -.03 3.312 1.092 4.381 2.934l.136 .243c1.033 -1.914 2.56 -3.114 4.291 -3.175l.209 -.002zm-9 2a1.5 1.5 0 0 0 0 3h3.143c-.741 -1.905 -1.949 -3.02 -3.143 -3zm8.983 0c-1.18 -.02 -2.385 1.096 -3.126 3h3.143a1.5 1.5 0 1 0 -.017 -3z" />
  </svg>
);
